import { forwardRef, type ComponentPropsWithoutRef } from 'react';
import s from './FormField.module.css';

type FormInputProps = ComponentPropsWithoutRef<'input'> & {
  /** react-hook-form field error message — adds red border + visible text. */
  error?: string;
};

/**
 * Input compatible with react-hook-form's `register` (uses forwardRef).
 *
 * @example
 * <FormField label="Назва" required error={errors.name?.message}>
 *   <FormInput {...register('name')} placeholder="Назва..." />
 * </FormField>
 */
export const FormInput = forwardRef<HTMLInputElement, FormInputProps>(
  ({ error, className, ...props }, ref) => (
    <input
      ref={ref}
      className={`${s.input} ${error ? s.hasError : ''} ${className ?? ''}`}
      {...props}
    />
  )
);

FormInput.displayName = 'FormInput';
